import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  @Input() showBackArrow: boolean = false;

  constructor(private location: Location) {}

  goBack(): void {
    this.location.back();
  }
}
